var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeepInsightBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_2293_16290)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3619 24.69C38.4333 24.3077 38.6362 23.9624 38.9354 23.7139C39.2346 23.4654 39.6113 23.3293 40.0002 23.3293C40.3892 23.3293 40.7659 23.4654 41.0651 23.7139C41.3643 23.9624 41.5672 24.3077 41.6386 24.69L43.3902 33.9533C43.5147 34.6119 43.8347 35.2177 44.3086 35.6916C44.7826 36.1655 45.3883 36.4856 46.0469 36.61L55.3102 38.3617C55.6926 38.4331 56.0379 38.636 56.2864 38.9352C56.5349 39.2344 56.6709 39.6111 56.6709 40C56.6709 40.3889 56.5349 40.7656 56.2864 41.0648C56.0379 41.364 55.6926 41.5669 55.3102 41.6383L46.0469 43.39C45.3883 43.5144 44.7826 43.8345 44.3086 44.3084C43.8347 44.7823 43.5147 45.3881 43.3902 46.0467L41.6386 55.31C41.5672 55.6923 41.3643 56.0376 41.0651 56.2861C40.7659 56.5346 40.3892 56.6707 40.0002 56.6707C39.6113 56.6707 39.2346 56.5346 38.9354 56.2861C38.6362 56.0376 38.4333 55.6923 38.3619 55.31L36.6102 46.0467C36.4858 45.3881 36.1658 44.7823 35.6919 44.3084C35.2179 43.8345 34.6122 43.5144 33.9536 43.39L24.6902 41.6383C24.3079 41.5669 23.9626 41.364 23.7141 41.0648C23.4656 40.7656 23.3296 40.3889 23.3296 40C23.3296 39.6111 23.4656 39.2344 23.7141 38.9352C23.9626 38.636 24.3079 38.4331 24.6902 38.3617L33.9536 36.61C34.6122 36.4856 35.2179 36.1655 35.6919 35.6916C36.1658 35.2177 36.4858 34.6119 36.6102 33.9533L38.3619 24.69Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3335 23.3333V29.9999",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 26.6667H50",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 56.6667C28.5078 56.6667 30.0002 55.1743 30.0002 53.3333C30.0002 51.4924 28.5078 50 26.6668 50C24.8259 50 23.3335 51.4924 23.3335 53.3333C23.3335 55.1743 24.8259 56.6667 26.6668 56.6667Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2293_16290",
    x1: 0,
    y1: 0,
    x2: 80,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e93125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ef5323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6903f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepInsightBotIcon);
export default __webpack_public_path__ + "static/media/deep-insight-bot-icon.bb7690c93117d6a5acbd5da9befeb376.svg";
export { ForwardRef as ReactComponent };